var isObject       = require('./_is-object')
  , setPrototypeOf = require('./_set-proto').set;
module.exports = function(that, target, C){
  var P, S = target.constructor;
  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
    setPrototypeOf(that, P);
  } return that;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_inherit-if-required.js
 ** module id = 156
 ** module chunks = 0
 **/